export enum QuestionType {
    YES_NO = 'YES_NO',
    FILL_IN = 'FILL_IN',
    MULTIPLE_ANSWER = 'MULTIPLE_ANSWER',
}
